import React, { useState } from 'react';
import { Alert } from '@mui/material';
import { BANNER_TEXT } from './constants';
import { daysSince } from '../../../utils/buyerInsightsDates';

const KEY = 'bi_data_building_dismissed';

// Spec §0.3: shown while the retailer has been live for fewer than 60 days; dismissible.
const DataBuildingBanner = ({ firstActivatedAt }) => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return window.localStorage.getItem(KEY) === '1';
    } catch (_e) {
      return false;
    }
  });
  if (!firstActivatedAt || dismissed || daysSince(firstActivatedAt) >= 60) return null;
  return (
    <Alert
      severity="info"
      sx={{ mb: 2 }}
      onClose={() => {
        setDismissed(true);
        try {
          window.localStorage.setItem(KEY, '1');
        } catch (_e) {
          /* ignore */
        }
      }}
    >
      {BANNER_TEXT}
    </Alert>
  );
};

export default DataBuildingBanner;
